export const topicsData = [
  { id: 1, name: '顶流塌房', heat: '987万', tag: '爆', icon: 'ri-fire-fill', color: 'primary' },
  { id: 2, name: '综艺内幕', heat: '856万', tag: '热', icon: 'ri-tv-2-line', color: 'accent' },
  { id: 3, name: '恋情曝光', heat: '743万', tag: '新', icon: 'ri-heart-pulse-line', color: 'primary' },
  { id: 4, name: '剧组风波', heat: '689万', tag: '热', icon: 'ri-film-line', color: 'accent' },
  { id: 5, name: '代言翻车', heat: '621万', tag: '', icon: 'ri-money-dollar-circle-line', color: 'secondary' },
  { id: 6, name: '选秀黑幕', heat: '598万', tag: '爆', icon: 'ri-trophy-line', color: 'primary' },
  { id: 7, name: '直播事故', heat: '534万', tag: '新', icon: 'ri-live-line', color: 'accent' },
  { id: 8, name: '私生饭事件', heat: '487万', tag: '热', icon: 'ri-alert-line', color: 'primary' },
  { id: 9, name: '综艺撕X', heat: '452万', tag: '', icon: 'ri-emotion-line', color: 'secondary' },
];

export const rankingData = [
  { rank: 1, title: '某顶流深夜密会神秘女子，酒店共度八小时', heat: '1287万', trend: 'up', change: '+32%', category: '恋情曝光', time: '3小时前', desc: '独家实拍画面曝光，细节令人震惊，粉丝群体集体破防。' },
  { rank: 2, title: '知名导演被曝片场霸凌演员，多段录音流出', heat: '1156万', trend: 'up', change: '+28%', category: '剧组风波', time: '5小时前', desc: '多位圈内人士站出来力挺爆料者，事件持续发酵。' },
  { rank: 3, title: '选秀节目导师私下嘲讽选手视频遭曝光', heat: '1023万', trend: 'hot', change: '+156%', category: '选秀黑幕', time: '2小时前', desc: '节目组紧急公关删除相关话题，但网友已大面积传播。' },
  { rank: 4, title: '某女星与前经纪人合同纠纷升级，涉及天价赔偿', heat: '967万', trend: 'up', change: '+18%', category: '合约纠纷', time: '6小时前', desc: '双方各执一词，法律文书细节被曝光引发热议。' },
  { rank: 5, title: '品牌方集体解约某翻车艺人，损失或超两亿', heat: '892万', trend: 'down', change: '-5%', category: '代言翻车', time: '8小时前', desc: '已有五家品牌宣布终止合作，业内预估连锁反应将扩大。' },
];

export const appData = {
  title: '黑料每日大赛 App',
  subtitle: '吃瓜更快一步',
  description: '第一时间推送最新黑料排行榜，随时随地掌握娱乐八卦动态。AI智能筛选全网热度数据，让你不错过任何一个劲爆话题。',
  features: ['实时热度推送', '独家深度扒皮', '高清原图直出', '评论区自由开麦'],
  downloadText: '立即下载 App',
  qrText: '扫码下载',
};

export const cardsData = [
  {
    id: 1, title: '某男团队内不和实锤？后台吵架视频意外流出', category: '男团八卦',
    desc: '巡演后台监控画面曝光，两名成员激烈争执，工作人员拉架无果。粉丝后援会紧急发声辟谣。',
    date: '2小时前', heat: '1023万', tag: '独家',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20photography%20with%20dramatic%20lighting%2C%20mysterious%20entertainment%20news%20theme%2C%20deep%20shadows%20with%20subtle%20crimson%20accents%2C%20cinematic%20composition%20on%20dark%20background%2C%20professional%20photojournalism%20aesthetic%20with%20shallow%20depth%20of%20field%2C%20atmospheric%20and%20sophisticated%20mood&width=640&height=400&seq=card-01&orientation=landscape',
  },
  {
    id: 2, title: '顶奢品牌代言人争夺战：两大花暗较劲内幕', category: '代言风波',
    desc: '知情人士爆料品牌方内部会议细节，两位一线女星团队各出奇招，最终花落谁家悬念十足。',
    date: '4小时前', heat: '956万', tag: '深扒',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20brand%20fashion%20editorial%20style%20with%20dramatic%20contrast%2C%20dark%20elegant%20atmosphere%2C%20mysterious%20celebrity%20gossip%20vibe%2C%20rich%20shadows%20and%20subtle%20gold%20accents%2C%20cinematic%20lighting%20on%20minimal%20dark%20background%2C%20sophisticated%20magazine%20quality&width=640&height=400&seq=card-02&orientation=landscape',
  },
  {
    id: 3, title: '某综艺导演被曝潜规则选手，节目组发声明否认', category: '综艺黑幕',
    desc: '匿名爆料人放出多张聊天截图，指控导演利用职务之便向选手施压。节目组称已报警处理。',
    date: '6小时前', heat: '887万', tag: '跟进',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20television%20studio%20backstage%20atmosphere%20with%20dark%20moody%20lighting%2C%20mysterious%20entertainment%20industry%20theme%2C%20deep%20contrast%20shadows%2C%20cinematic%20composition%20on%20dark%20background%2C%20professional%20photojournalism%20style%20with%20red%20accent%20glow&width=640&height=400&seq=card-03&orientation=landscape',
  },
  {
    id: 4, title: '当红小生深夜急诊就医，工作室回应称只是疲劳过度', category: '健康预警',
    desc: '粉丝拍到偶像凌晨从医院侧门离开，神情憔悴。此前该艺人连续工作超过72小时。',
    date: '8小时前', heat: '812万', tag: '关注',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20night%20scene%20outside%20hospital%20with%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20paparazzi%20style%20photography%2C%20deep%20shadows%20and%20ambient%20light%2C%20cinematic%20noir%20aesthetic%20on%20dark%20background%2C%20atmospheric%20editorial%20quality&width=640&height=400&seq=card-04&orientation=landscape',
  },
  {
    id: 5, title: '某剧组因预算超支停拍，主演片酬曝光引争议', category: '行业揭秘',
    desc: '内部财务文件泄露显示主演单集片酬惊人数字，网友直呼"普通人要奋斗几辈子"。',
    date: '10小时前', heat: '756万', tag: '热议',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20set%20atmosphere%20with%20dramatic%20lighting%2C%20dark%20moody%20behind%20the%20scenes%20vibe%2C%20professional%20movie%20production%20theme%2C%20deep%20contrast%20shadows%20with%20subtle%20warm%20accents%2C%20editorial%20photography%20on%20dark%20background%2C%20atmospheric%20quality&width=640&height=400&seq=card-05&orientation=landscape',
  },
  {
    id: 6, title: '知名经纪人被爆私吞艺人收入，涉及金额超千万', category: '金钱纠纷',
    desc: '多位艺人联名举报经纪人财务不透明，账目混乱疑点重重。圈内其他经纪人集体沉默。',
    date: '12小时前', heat: '698万', tag: '重磅',
    image: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20atmosphere%20with%20dramatic%20shadow%20play%2C%20mysterious%20financial%20scandal%20theme%2C%20cinematic%20noir%20lighting%20with%20deep%20contrast%2C%20professional%20editorial%20photography%20on%20dark%20background%2C%20atmospheric%20and%20sophisticated%20mood%20with%20subtle%20red%20accents&width=640&height=400&seq=card-06&orientation=landscape',
  },
  {
    id: 7, title: '某女星整容前后对比照被医院内部流出，本人回应', category: '颜值争议',
    desc: '某整形医院员工违规泄露客户档案，对比照片引发全网讨论。当事人发文称"我美我的"。',
    date: '14小时前', heat: '645万', tag: '吃瓜',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20dramatic%20portrait%20photography%20with%20split%20lighting%2C%20dark%20moody%20atmosphere%2C%20beauty%20and%20fashion%20editorial%20style%2C%20deep%20shadows%20and%20striking%20contrast%2C%20cinematic%20composition%20on%20dark%20background%2C%20professional%20magazine%20quality%20aesthetic&width=640&height=400&seq=card-07&orientation=landscape',
  },
];

export const carouselData = [
  {
    id: 1, title: '2024年度十大塌房事件回顾', category: '年度专题',
    desc: '从顶流艺人到知名导演，回顾今年最令人震惊的娱乐圈翻车现场，每一个都足以载入史册。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20dark%20moody%20editorial%20photography%20for%20year%20end%20special%20feature%2C%20dramatic%20contrast%20lighting%20with%20deep%20shadows%2C%20mysterious%20entertainment%20industry%20atmosphere%2C%20sophisticated%20magazine%20quality%20with%20crimson%20red%20accents%2C%20abstract%20artistic%20composition%20on%20dark%20background&width=800&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2, title: '娱乐圈资本局：谁在幕后操控热搜？', category: '深度调查',
    desc: '揭秘娱乐营销产业链背后的资本运作，买热搜、控评、水军的完整生态链首次全面曝光。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20power%20and%20money%20theme%20editorial%20photography%2C%20dramatic%20chiaroscuro%20lighting%2C%20mysterious%20business%20conspiracy%20atmosphere%2C%20cinematic%20composition%20on%20dark%20background%2C%20sophisticated%20investigative%20journalism%20aesthetic%20with%20gold%20and%20crimson%20accents&width=800&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3, title: '跨国恋情大盘点：那些你不知道的异国CP', category: '恋情专题',
    desc: '盘点娱乐圈那些低调的跨国恋情，从中韩到中美，明星们的海外浪漫故事一次看完。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20dark%20moody%20editorial%20photography%20with%20couple%20silhouette%2C%20dramatic%20atmospheric%20lighting%2C%20mysterious%20international%20romance%20theme%2C%20cinematic%20composition%20on%20dark%20background%2C%20sophisticated%20fashion%20magazine%20aesthetic%20with%20subtle%20warm%20accents&width=800&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4, title: '综艺节目剪辑黑幕：你看到的都是假的', category: '行业揭秘',
    desc: '资深剪辑师匿名爆料综艺后期剪辑套路，魔鬼剪辑如何制造矛盾、塑造人设全解读。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20television%20production%20control%20room%20atmosphere%20with%20dramatic%20lighting%2C%20mysterious%20behind%20the%20scenes%20entertainment%20industry%20theme%2C%20cinematic%20noir%20aesthetic%2C%20deep%20shadows%20with%20monitor%20glow%2C%20professional%20editorial%20photography%20on%20dark%20background&width=800&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5, title: '从选秀冠军到查无此人：消失的他们去哪了', category: '追踪报道',
    desc: '曾经红极一时的选秀冠军如今纷纷销声匿迹，我们追踪了他们的近况，结果令人唏嘘。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20dark%20moody%20photography%20with%20spotlight%20on%20empty%20stage%2C%20dramatic%20contrast%20lighting%2C%20mysterious%20fame%20and%20disappearance%20theme%2C%20deep%20shadows%20with%20single%20light%20beam%2C%20editorial%20magazine%20quality%20on%20dark%20background%2C%20atmospheric%20sophisticated%20aesthetic&width=800&height=600&seq=carousel-05&orientation=landscape',
  },
  {
    id: 6, title: '00后新生代艺人潜力榜：谁将成为下一个顶流', category: '未来之星',
    desc: '从演技、颜值、资源、情商多维度分析，这几位00后新星最有希望冲击顶流宝座。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20rising%20star%20theme%20editorial%20photography%2C%20mysterious%20spotlight%20atmosphere%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20sophisticated%20fashion%20magazine%20aesthetic%2C%20abstract%20artistic%20composition%20on%20dark%20background%20with%20subtle%20crimson%20and%20gold%20highlights&width=800&height=600&seq=carousel-06&orientation=landscape',
  },
];

export const indexData = [
  { id: 1, icon: 'ri-fire-fill', title: '今日热度榜', count: '128条', desc: '实时追踪全网最热话题' },
  { id: 2, icon: 'ri-trophy-line', title: '黑料大赛排名', count: '50强', desc: '每日更新选手排名' },
  { id: 3, icon: 'ri-heart-pulse-line', title: '恋情曝光专区', count: '36条', desc: '最新明星恋情动态' },
  { id: 4, icon: 'ri-film-line', title: '剧组探班爆料', count: '42条', desc: '一线拍摄现场直击' },
  { id: 5, icon: 'ri-live-line', title: '直播翻车合集', count: '29条', desc: '直播事故一网打尽' },
  { id: 6, icon: 'ri-team-line', title: '饭圈大战实录', count: '55条', desc: '粉丝团互撕全记录' },
  { id: 7, icon: 'ri-money-dollar-circle-line', title: '代言签约内幕', count: '33条', desc: '品牌合作背后的故事' },
  { id: 8, icon: 'ri-album-line', title: '综艺内幕揭秘', count: '47条', desc: '你所不知道的综艺真相' },
];

export const featuresData = [
  {
    id: 1, icon: 'ri-flashlight-line', title: '全网最快爆料',
    desc: '7x24小时不间断监测娱乐动态，AI智能抓取结合人工审核，确保你第一时间吃到最新鲜的瓜。覆盖微博、抖音、小红书等30+主流平台。',
  },
  {
    id: 2, icon: 'ri-shield-check-line', title: '独家深度扒皮',
    desc: '专业编辑团队追根溯源，不满足于表面信息，深入挖掘事件背后的真相与逻辑，让你看得懂、吃得透、聊得来。',
  },
  {
    id: 3, icon: 'ri-bar-chart-grouped-line', title: '数据化热度榜',
    desc: '基于全网搜索量、讨论量、转发量等多维数据加权计算，打造最客观的娱乐八卦热度排名。拒绝水军操控，真实反映吃瓜风向。',
  },
  {
    id: 4, icon: 'ri-user-voice-line', title: '吃瓜群众社区',
    desc: '开放的评论区让你畅所欲言，理性讨论、趣味吐槽皆可。这里是全网最活跃的娱乐八卦讨论社区，每天产生数十万条高质量评论。',
  },
];

export const contactData = {
  title: '有料？来爆！',
  description: '如果你有独家消息、一手黑料或者娱乐圈内幕线索，欢迎通过以下方式联系我们。我们承诺对所有爆料人信息绝对保密，重大线索将提供丰厚奖励。你的每一次爆料，都可能成为明天的头条。',
  email: 'tips@heiliaodaily.com',
  wechat: 'HLMRDS_Official',
  tips: '爆料经核实采纳后，将根据话题热度给予爆料人相应奖励。请在爆料时提供尽可能详细的证据材料。',
};

export const mediaData = [
  { id: 1, title: '独家实拍：某顶流深夜出没酒吧，与神秘人密谈两小时', duration: '03:28', views: '892万', date: '3小时前', category: '独家跟拍', image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20night%20scene%20outside%20luxury%20bar%20with%20dramatic%20lighting%2C%20paparazzi%20style%20photography%2C%20mysterious%20entertainment%20news%20theme%2C%20deep%20shadows%20with%20ambient%20city%20lights%2C%20professional%20editorial%20video%20thumbnail%20quality%2C%20atmospheric%20noir%20aesthetic&width=800&height=450&seq=media-01&orientation=landscape' },
  { id: 2, title: '深度解析：2024娱乐圈资本洗牌背后的权力游戏', duration: '15:42', views: '756万', date: '6小时前', category: '深度分析', image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20corporate%20power%20theme%20video%20thumbnail%2C%20cinematic%20lighting%20with%20deep%20contrast%20shadows%2C%20mysterious%20business%20analysis%20atmosphere%2C%20professional%20editorial%20quality%20with%20gold%20and%20crimson%20accents%2C%20sophisticated%20documentary%20style&width=800&height=450&seq=media-02&orientation=landscape' },
  { id: 3, title: '现场直击：知名颁奖礼后台明星真实互动全记录', duration: '08:15', views: '634万', date: '9小时前', category: '现场直击', image: 'https://readdy.ai/api/search-image?query=Dark%20behind%20the%20scenes%20awards%20show%20atmosphere%20with%20dramatic%20lighting%2C%20mysterious%20entertainment%20event%20backstage%20vibe%2C%20cinematic%20editorial%20photography%2C%20deep%20shadows%20with%20subtle%20spotlight%20glow%2C%20professional%20video%20thumbnail%20aesthetic&width=800&height=450&seq=media-03&orientation=landscape' },
  { id: 4, title: '热搜背后：一条娱乐热搜从策划到霸榜的完整产业链', duration: '12:06', views: '521万', date: '12小时前', category: '行业揭秘', image: 'https://readdy.ai/api/search-image?query=Dark%20social%20media%20analytics%20theme%20video%20thumbnail%2C%20dramatic%20lighting%20with%20data%20visualization%20vibe%2C%20mysterious%20internet%20trend%20atmosphere%2C%20professional%20editorial%20quality%20on%20dark%20background%2C%20sophisticated%20minimalist%20aesthetic&width=400&height=250&seq=media-small-04&orientation=landscape' },
  { id: 5, title: '吃瓜指南：本月最值得关注的五对疑似情侣大盘点', duration: '06:50', views: '468万', date: '15小时前', category: '吃瓜合集', image: 'https://readdy.ai/api/search-image?query=Dark%20romantic%20entertainment%20gossip%20theme%20video%20thumbnail%2C%20dramatic%20cinematic%20lighting%2C%20mysterious%20couple%20silhouette%20atmosphere%2C%20professional%20editorial%20quality%20on%20dark%20background%2C%20sophisticated%20fashion%20magazine%20aesthetic&width=400&height=250&seq=media-small-05&orientation=landscape' },
];

export const aboutData = {
  title: '关于黑料每日大赛',
  intro: '黑料每日大赛成立于2023年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为吃瓜群众提供最快、最全、最真实的娱乐八卦内容，打造全网最具影响力的娱乐资讯社区。',
  description: '平台每日追踪超过500个娱乐话题源，覆盖明星动态、综艺内幕、影视剧透、时尚八卦等多个领域。专业编辑团队24小时轮值，确保重要娱乐事件发生后15分钟内即上线报道。我们坚持客观中立的内容立场，所有爆料均标注信息来源等级，让读者自行判断可信度。',
  stats: [
    { value: '500+', label: '每日话题追踪' },
    { value: '3000万+', label: '月活跃用户' },
    { value: '15分钟', label: '热点响应速度' },
    { value: '98%', label: '用户满意度' },
  ],
};

export const updatesData = [
  { id: 1, date: '07-30 14:32', title: '某顶流工作室发布律师函，否认全部网络传闻', type: '快讯' },
  { id: 2, date: '07-30 12:18', title: '综艺《星光大道》被曝暗箱操作，节目组回应称将启动内部调查', type: '热点' },
  { id: 3, date: '07-30 10:05', title: '某女星晒出体检报告回应怀孕传闻："别再造谣了"', type: '回应' },
  { id: 4, date: '07-30 08:42', title: '三大视频平台联合发布抵制恶意剪辑声明', type: '行业' },
  { id: 5, date: '07-29 22:15', title: '某选秀节目选手集体发声，控诉节目组不公正待遇', type: '爆料' },
  { id: 6, date: '07-29 18:30', title: '知名娱乐记者预告明日将有"年度级大瓜"曝光', type: '预告' },
  { id: 7, date: '07-29 15:00', title: '某品牌宣布与翻车艺人解约，违约金条款细节曝光', type: '跟进' },
];

export const commentsData = [
  {
    id: 1, name: '吃瓜不嫌事大', avatar: 'https://readdy.ai/api/search-image?query=Default%20generic%20anonymous%20user%20avatar%20silhouette%20with%20simple%20dark%20gray%20background%2C%20minimalist%20flat%20design%20with%20clean%20circle%20shape&width=80&height=80&seq=avatar-01&orientation=squarish',
    date: '2小时前', content: '这个瓜我吃了三天了，越吃越有意思。建议大家去翻翻他三年前的那条微博，现在回看简直是预言级别的。娱乐圈果然没有无缘无故的巧合。', likes: 2563,
  },
  {
    id: 2, name: '理性吃瓜人', avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20anonymous%20user%20profile%20avatar%20with%20simple%20dark%20background%20circle%20shape%2C%20clean%20flat%20design&width=80&height=80&seq=avatar-02&orientation=squarish',
    date: '4小时前', content: '说句公道话，这事双方都有问题。但资本下场洗白的痕迹太明显了，昨天突然多了几十个营销号统一话术，当我们吃瓜群众是傻子吗？', likes: 1892,
  },
  {
    id: 3, name: '娱乐圈纪检委', avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20default%20user%20profile%20picture%20silhouette%20on%20dark%20gray%20background%2C%20clean%20geometric%20circle%20design&width=80&height=80&seq=avatar-03&orientation=squarish',
    date: '5小时前', content: '作为从业十年的圈内人，我只能说文章里写的内容只触及了冰山一角。真正的大料还在后面，就看有没有人敢爆了。评论区蹲一个后续。', likes: 3421,
  },
];

export const faqData = [
  {
    id: 1,
    question: '黑料每日大赛的内容来源是什么？',
    answer: '我们的内容主要来源于三个渠道：一是专业编辑团队对全网娱乐资讯的实时监测与整合；二是匿名爆料人提供的一手线索，经我们核实后发布；三是合作媒体和自媒体的授权转载。所有内容发布前均经过多轮事实核查，确保信息的真实性和可靠性。',
  },
  {
    id: 2,
    question: '如何向黑料每日大赛进行匿名爆料？',
    answer: '你可以通过页面上方的"联系我们"板块获取我们的联系方式。我们支持邮件爆料和微信沟通两种方式。我们郑重承诺：对所有爆料人信息进行严格保密，绝不向第三方透露爆料人身份。对于具有重大传播价值的独家线索，我们将根据实际热度给予爆料人相应奖励。',
  },
  {
    id: 3,
    question: '热度排行榜的计算方式是怎样的？',
    answer: '我们的热度排行榜基于一套自主研发的多维度算法，综合参考了全网搜索量、社交媒体讨论量、内容转发量、评论互动量和话题持续时长等五个核心指标，通过加权计算得出最终热度值。排行榜每30分钟自动更新一次，确保数据时效性。',
  },
  {
    id: 4,
    question: '如果发现内容与事实不符，如何申请更正或删除？',
    answer: '我们高度重视内容的真实性和准确性。如果你发现平台上的内容存在事实性错误，或者相关内容侵犯了你的合法权益，请通过"联系我们"板块中列出的邮箱与我们取得联系，并提供详细的更正/删除理由和相关证明材料。我们的法务团队将在24小时内审核并反馈处理结果。',
  },
];

export const navLinks = [
  { id: 'features', label: '平台特色' },
  { id: 'carousel', label: '专题精选' },
  { id: 'ranking', label: '热度排行榜' },
  { id: 'index', label: '内容索引' },
];